import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    previousRoute: null,
    isLoading: false,
    displayModal: false,
    general: {
        catalog: false,
        demographicBreakdown: false,
        frequency: false,
        quantile: false,
        surfintensity: false,
        accuracy: false,
        bootstrapPush: false,
        xdevice: false,
        firstPartyCookie: false,
        providerFirstIdActivated: false,
    },
    settingName: null,
    sociodemo: {
        demographic: false,
        behavioral: false,
        geography: false,
        technology: false
    },
    wamFactory: {
        wamfactory: false,
        bootstrap: false,
        logs: false,
        estimation: false
    },
    dataMining: {
        datamining: false,
        encryption: false,
        fullmode: false,
        secondparty: false,
        thirdparty: false,
        altid: false,
        sshKey: ''
    },
    extraTaxo: {
        isLoading: false,
        activeTaxo: null,
        list: {}
    },
    selectedRowId: null,
    sharing: {
        sharingType: 'taxonomies',
        activeSharing: [],
        sharingToAdd: [],
        sharingToRemove: [],
        isLoading: false
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
